import { Box, Typography } from "@mui/material";
import { Motion } from "../Motion/Motion";
import { appDarkBlue, appRed } from "../../Classes/theme";


export default function TitleTextLayout({
    sxProps = {},
    sxButton = {},
    sxTitle = {}, // Mensi font u nekterych
    sxText = {},
    smTitle,
    title,
    text,
    buttonText,
    onButtonClick,
    openPath = null,
}) {
    const boxStyle = {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
    };

    return (
        <Box
            sx={{
                ...boxStyle,
                pt: "20px",
                maxWidth: "400px",
                minWidth: { xs: "290px", sm: "300px", md: '100%' },
                ...sxProps,
            }}
        >
            <Typography
                sx={{
                    maxWidth: "320px",
                    textAlign: "left",
                    mt: "40px",
                    ...sxText,
                }}
                variant="blue"
            >
                {smTitle || ""}
            </Typography>
            <Typography
                component="h1"
                sx={{
                    mt: "18px",
                    textAlign: "left",
                    ...sxTitle,
                }}
                variant="title"
            >
                {title || ""}
            </Typography>
            <Typography
                sx={{
                    maxWidth: "320px",
                    textAlign: "left",
                    mt: "32px",
                    mb: "42px",
                    ...sxText,
                }}
            >
                {text || ""}
            </Typography>
            {buttonText && (
                <Motion>
                    <Box
                        sx={{
                            bgcolor: appDarkBlue,
                            height: "52px",
                            minWidth: '120px',
                            width: "fit-content",
                            borderRadius: "42px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            ...sxButton,
                        }}
                        onClick={() => {
                            if (onButtonClick) {
                                onButtonClick();
                            } else if (openPath) {
                                window.open(openPath, "blank");
                            }
                        }}
                    >
                        <Typography
                            sx={{ mx: "30px", mt: '2px' }}
                            variant="button"
                        >
                            {buttonText || ""}
                        </Typography>
                    </Box>
                </Motion>
            )}
        </Box>
    );
}
